import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  createEmailModule,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";
import styles from "../../components/Modal.module.css";

const identity = (data) => data;

export class CreateEmailModuleModal extends Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
    this.nameRef = createRef();
    this.templateIdRef = createRef();
  }

  componentWillMount() {
    const { accountId } = this.props;
    this.props.emailTemplatesList(accountId);
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  create(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId } = this.props;
    this.props
      .createEmailModule(accountId, {
        name: this.nameRef?.current.value,
        templateId: this.templateIdRef?.current.value,
      })
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(
          `/clients/${accountId}/email-modules/${nextId}`
        );
      })
      .then(this.props.closeModal);
  }

  renderTemplateOption(template) {
    return (
      <option value={template.id} key={template.id}>
        {template.name}
      </option>
    );
  }

  render() {
    const { emailTemplates } = this.props;

    return (
      <Modal>
        <ModalHeader>Create Email Module</ModalHeader>
        <ModalContent>
          <form onSubmit={this.create}>
            <div className={styles.flex}>
              <label>Name</label>
              <input ref={this.nameRef} autoFocus />
            </div>
            <div className={styles.flex}>
              <label>Template</label>
              <select ref={this.templateIdRef}>
                {emailTemplates.map(this.renderTemplateOption)}
              </select>
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.create}>Create</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CreateEmailModuleModal.propTypes = {
  createEmailModule: PropTypes.func.isRequired,
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  emailTemplates: PropTypes.array.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const accountId = params.accountId;
  const emailTemplatesPagination = state.pagination.emailTemplates || {};
  const emailTemplates = (emailTemplatesPagination.ids || [])
    .map((id) => state.entities.emailTemplate[id])
    .filter(identity);

  return {
    accountId,
    emailTemplates,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  createEmailModule,
  emailTemplatesList,
  gotoUrl,
})(CreateEmailModuleModal);
